import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ImportersApi } from 'api';

/**
 * Custom React Query hook to delete a user
 *
 * @param {{ onSuccess?: () => void; onError?: (error: Error) => void }} options
 * @returns {import("@tanstack/react-query").UseMutationResult}
 */
export function useDeleteUser({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => ImportersApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['users']);
      typeof onSuccess === 'function' && onSuccess();
    },
    onError: (error) => {
      typeof onError === 'function' && onError(error);
    },
  });
}
